<template>
  <div class='EnbMarketing'>
    <marketing-nave/>
    <div class="cont-view">
      <router-view/>
    </div>
    <div class="cont-btn">
      <button :disabled="updating" @click="update" >
        <span v-if="!updating">Atualizar</span>
        <vue-spinner size="30" v-if="updating"/>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MarketingNave from './MarketingNave'
export default {
  name: 'EnbMarketing',
  components: { MarketingNave },
  data () {
    return {
      updating: false
    }
  },
  computed: {
    ...mapGetters(['Themes', 'Empresa'])
  },
  methods: {
    ...mapActions(['ChangeTheme', 'UpdatePrefComp', '_UpdatePreference', '_UpdateMapsNets', '_UpdateTagmanager']),
    update () {
      this.updating = true
      this._UpdateMapsNets({
        maps: this.Empresa.maps,
        instagram: this.Empresa.instagram,
        facebook: this.Empresa.facebook,
        whatsapp: this.Empresa.whatsapp.replace('(', '').replace(')', '').replace(' ', '').replace('-', '')
      })
      .then(() => this._UpdatePreference())
      .then(() => this._UpdateTagmanager({
        tagmanagerhead: this.Empresa.tagmanagerhead,
        tagmanagerbody: this.Empresa.tagmanagerbody
      }))
      .then(() => {
        this.updating = false
      })
    }
  }
}
</script>

<style scoped>
/* coluna: nave e botão com a altura deles, o conteúdo ocupa o resto e rola sozinho */
.EnbMarketing {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 2%;
  display: flex;
  flex-direction: column;
}

.cont-view {
  width: 96%;
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.cont-btn {
  text-align: left;
  padding-left: 1%;
  padding-top: 1%;
}

button {
  border: 0;
  background-color: #000000;
  color: #FFFFFF;
  border-radius: 5px;
  padding: 1%;
  font-size: 16px;
  cursor: pointer
}

button:disabled {
  opacity: 0.60;
}

@media (max-width: 500px) {
  .EnbMarketing {
    height: 75%;
  }
}
</style>
